import { render, staticRenderFns } from "./CollaboratorsTable.vue?vue&type=template&id=f0add550"
import script from "./CollaboratorsTable.vue?vue&type=script&lang=js"
export * from "./CollaboratorsTable.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports